module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGl2ZWxsb18xIiBkYXRhLW5hbWU9IkxpdmVsbG8gMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTYuMTggMTIuNzEiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDpub25lO3N0cm9rZTojZmZmZmZmO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MS41cHg7fTwvc3R5bGU+PC9kZWZzPjxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjE1LjQzIiB5MT0iNi4zNiIgeDI9IjAuNzUiIHkyPSI2LjM2Ii8+PHBvbHlsaW5lIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSI5Ljc1IDExLjk2IDE1LjQzIDYuMzYgOS43NSAwLjc1Ii8+PC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/front/assets/images/svg/white/icone_arrow-3.svg
// module id = yfn1
// module chunks = 9